"use client";
import Image from "next/image";
import 프랜차이즈_목록_이미지1 from "/public/assets/pc/images/pic/img_franchise_list1.webp";
import 프랜차이즈_목록_이미지2 from "/public/assets/pc/images/pic/img_franchise_list2.webp";
import styles from "./프랜차이즈_목록_Desktop.module.css";

export type 프랜차이즈_목록Props = {
  inline?: boolean;
}

export const 프랜차이즈_목록 = (props?: 프랜차이즈_목록Props) => {
  return (
    <div className={props?.inline === true ? "section section11" : "section section10"}>
      <div className="inner">
        <div style={{ textAlign: "center", color: "#ffffff", fontSize: "40px", lineHeight: "46px", fontWeight: 700, letterSpacing: "-3%" }}>마켓봄은 프랜차이즈와 함께 성장해 나갑니다.</div>
        <div id="franchise-slider" style={{marginTop: "50px"}}>
          <div className={styles["image-box1"]}>
            <Image src={프랜차이즈_목록_이미지1} alt="프랜차이즈" style={{ marginRight: "20px" }} />
            <Image src={프랜차이즈_목록_이미지1} alt="프랜차이즈" />
          </div>
        </div>
        <div id="franchise-slider" style={{marginTop: "30px"}}>
          <div className={styles["image-box2"]}>
            <Image src={프랜차이즈_목록_이미지2} alt="프랜차이즈" style={{ marginRight: "20px" }} />
            <Image src={프랜차이즈_목록_이미지2} alt="프랜차이즈" />
          </div>
        </div>
      </div>
    </div>
  );
};
